<div class="row">
    <div class="col-md-auto icon-column">
        <app-camp-icon [iconName]="item.categoryIcon"></app-camp-icon>
    </div>
    <div class="col">
        <div class="d-flex w-100 justify-content-between overflow-elipsis-wrap">
            <h6 class="mb-1 main-blue bolded overflow-elipsis" hznTestId="camp-row-name">
                {{ item.name }}
            </h6>
            <small class="text-muted"
                ><span class="list-row-value bolded {{ item.status }}" hznTestId="camp-row-status">{{
                    item.status
                }}</span></small
            >
        </div>
        @if (item.dateFrom) {
            <p class="mb-1 bolded" hznTestId="camp-row-dates">
                {{ item.dateFrom | bcDate }} - {{ item.dateTo | bcDate }}
            </p>
        }
        @if (!item.dateFrom) {
            <p class="mb-1" hznTestId="camp-row-dates">{{ "CampList.NoSessionDefined" | translate }}</p>
        }
        <small class="text-muted"
            ><span class="bolded">{{ "CampList.category" | translate }}</span>
            <span hznTestId="camp-row-category">{{ item.category }}</span>,
            <span class="bolded">{{
                "CampList.isVisibleInConnect" | translate
            }}</span>
            <span hznTestId="camp-row-visible">{{ item.isVisibleToMembers }}</span>,
            <span class="bolded">{{ "CampList.createdAt" | translate }}</span>
            <span hznTestId="camp-row-created-at">{{ item.createdAt | bcDateTime: "LLL" }}</span>,
            <span class="bolded">{{ "CampList.type" | translate }}</span>
            <span hznTestId="camp-row-type">{{ item.type }}</span></small
        >
    </div>
    <div class="col-md-auto">
        <div>
            <button
                class="btn btn-action btn-light width-130"
                bcClick
                (clicked)="onDetailsView()"
            >
                {{ "CampList.campDetails" | translate }}
            </button>
        </div>
        <div class="voffset-2">
            <button
                class="btn btn-action btn-light width-130"
                bcClick
                (clicked)="onEnrollmentView()"
            >
                {{ "CampList.enrollmentView" | translate }}
            </button>
        </div>
        <div class="voffset-2">
            <button
                class="btn btn-action btn-light width-130"
                bcClick
                (clicked)="onBookingsView()"
            >
                {{ "CampList.campCareBookings" | translate }}
            </button>
        </div>
    </div>
</div>
